import React from 'react';
import PropTypes from 'prop-types';

function TableData({ cell }) {
  const { col8 } = cell.row.values;

  const getVRB = () =>
    col8 !== undefined ? <td {...cell.getCellProps()}>CHF {cell.render('Cell')}</td> : <td></td>;

  switch (cell.column.id) {
    case 'col8':
      return getVRB();
    default:
      return <td {...cell.getCellProps()}>{cell.render('Cell')}</td>;
  }
}

TableData.propTypes = {
  children: PropTypes.node,
};

export default TableData;
